import axios from 'axios'

export async function make3CIPageKioskMobileSessionPaymentEndpoint() {
  return (await axios.post('/session-payments/3C-ipage')).data
}
